import { configureStore, type ThunkAction, type Action } from '@reduxjs/toolkit'
import { proximaApi } from '../api/proximaApi'
import { authLocalStorageMiddleware } from '../modules/auth/authLocalStorageMiddleware'

import authSliceReducer from '../modules/auth/authSlice'
import uiWidgetsReducer from '../modules/shared/components/ui-widgets/uiWidgetsSlice'

export const store = configureStore({
  reducer: {
    [proximaApi.reducerPath]: proximaApi.reducer,

    // Feature slices
    authSlice: authSliceReducer,
    uiWidgets: uiWidgetsReducer
  },

  // preloadedState: rehydrateAuthSliceFromLocalStorage,

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    proximaApi.middleware,
    authLocalStorageMiddleware
  )
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
